export const GRADIENT = {
  BLUE: 'linear-gradient(45deg,  #0033cc,  #c8c2ff)',
  REVERSE_BLUE: `linear-gradient(
      45deg, #c8c2ff, #0033cc)`,
}
